import { cn } from '@Utils/cn';

import FieldShell from './FieldShell';

export interface ThumbnailOption {
  value: string;
  label: string;
  preview: React.ReactNode;
}

interface ThumbnailPickerFieldProps {
  title?: string;
  description?: string;
  options: ThumbnailOption[];
  value?: string;
  onChange: (value: string) => void;
}

/** Pick-one-of-N where each option renders as a small visual preview. */
export default function ThumbnailPickerField({
  title,
  description,
  options,
  value,
  onChange,
}: ThumbnailPickerFieldProps) {
  return (
    <FieldShell title={title} description={description}>
      <div className="flex gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-label={option.label}
            title={option.label}
            onClick={() => onChange(option.value)}
            className={cn(
              'grow rounded-lg border-2 border-transparent p-0.5',
              value === option.value && 'border-zinc-900',
            )}
          >
            {option.preview}
          </button>
        ))}
      </div>
    </FieldShell>
  );
}
